/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button } from "@/components/ui/button";
import { DialogFooter } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { useReactForm } from "../react-hook/use-react-form";
import { IconRender } from "@/components/shared/Icon-render";
import {
  ArrayInputV2,
  MultiSelectWithSearch,
  PasswordInput,
} from "@/components/form-input";
import { Switch } from "@/components/ui/switch";
import { RequiredInput } from "@/components/shared/required-input";
import { SUPPORTED_DOCUMENT_LIST } from "@/global-data/global-const";
import { SenderEmailSettings } from "../sender-email-settings";
import { useMemo, useState } from "react";
import { useWatch } from "react-hook-form";
import { cn } from "@/lib/utils";

type UserFormType = {
  formData: any;
  onOpenChange: (prop: any) => void;
  onFormSubmit: (prop: boolean) => Promise<void>;
  open: boolean;
  isFormReset: boolean;
  setIsFormReset: (prop: boolean) => void;
  emailProvider?: string | undefined;
};
export const ReactForm = ({
  formData,
  onOpenChange,
  onFormSubmit,
  open,
  isFormReset,
  setIsFormReset,
  emailProvider,
}: UserFormType) => {
  const { form, onSubmit } = useReactForm({
    formData,
    onOpenChange,
    onFormSubmit,
    open,
  });

  console.log({ errors: form.formState.errors });

  const [isDisable, setIsDisable] = useState(false);

  const download_attachment_from_url = useWatch({
    name: "settings.download_attachment_from_url",
    control: form.control,
  });
  const ignore_document_types = useWatch({
    name: "settings.ignore_document_types",
    control: form.control,
  });

  const selectedEmailProvider = useMemo(() => {
    if (formData?.email_id) {
      form.setValue(
        "settings.email_provider",
        formData?.settings?.email_provider,
      );
      return formData?.settings?.email_provider;
    }
    form.setValue("settings.email_provider", emailProvider);
    return emailProvider;
  }, [emailProvider, formData]);

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)}>
        <div className="grid grid-cols-2 gap-x-6 gap-y-5 px-6">
          <FormField
            control={form.control}
            name="settings.email_provider"
            render={({ field }) => (
              <FormItem>
                <FormLabel>
                  Email Provider
                  <RequiredInput />
                </FormLabel>
                <FormControl>
                  <Input placeholder="Email Provider" disabled {...field} />
                </FormControl>

                <FormMessage />
              </FormItem>
            )}
          />
          <FormField
            control={form.control}
            name="email_id"
            render={({ field }) => (
              <FormItem>
                <FormLabel>
                  Email Address
                  <RequiredInput />
                </FormLabel>
                <FormControl>
                  <Input placeholder="Email Address" {...field} />
                </FormControl>

                <FormMessage />
              </FormItem>
            )}
          />
          <div
            className={cn(selectedEmailProvider === "gmail" ? "" : "hidden")}
          >
            {formData?.email_id ? (
              <FormItem>
                <FormLabel>Password</FormLabel>
                <div className=" relative">
                  <Input type="password" value={"---------"} readOnly />
                  <Button
                    size={"sm"}
                    variant={"link"}
                    className="absolute right-1 top-1 text-sm"
                    onClick={() => setIsFormReset(!isFormReset)}
                  >
                    Reset Password
                  </Button>
                </div>
                <FormMessage />
              </FormItem>
            ) : (
              <FormField
                control={form.control}
                name="password"
                render={({ field }) => (
                  <FormItem>
                    <FormLabel>Password</FormLabel>
                    <FormControl>
                      <PasswordInput placeholder="Password" field={field} />
                    </FormControl>
                    <FormMessage />
                  </FormItem>
                )}
              />
            )}
          </div>
          <div
            className={cn(selectedEmailProvider === "outlook" ? "" : "hidden")}
          >
            <FormField
              control={form.control}
              name="azure_app_settings.tenant_id"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>Tenant Id</FormLabel>
                  <FormControl>
                    <Input placeholder="Tenant Id" {...field} />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
          </div>

          <div className="grid grid-cols-3">
            <FormField
              control={form.control}
              name="enable"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>Enable</FormLabel>
                  <FormControl>
                    <div>
                      <Switch
                        className="mt-[5px]"
                        checked={field.value}
                        onCheckedChange={field.onChange}
                      />
                    </div>
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
            <FormField
              control={form.control}
              name="read_body_content"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>Read body content</FormLabel>
                  <FormControl>
                    <div>
                      <Switch
                        className="mt-[5px]"
                        checked={field.value}
                        onCheckedChange={field.onChange}
                      />
                    </div>
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
            <FormField
              control={form.control}
              name="read_attachments"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>Read attachments</FormLabel>
                  <FormControl>
                    <div>
                      <Switch
                        className="mt-[5px]"
                        checked={field.value}
                        onCheckedChange={field.onChange}
                      />
                    </div>
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
          </div>
          <div className="col-span-full grid grid-cols-1 gap-5 md:grid-cols-2">
            <FormField
              control={form.control}
              name="settings.download_attachment_from_url"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>Download attachment from url</FormLabel>
                  <FormControl>
                    <div>
                      <Switch
                        className="mt-[5px]"
                        checked={field.value}
                        onCheckedChange={field.onChange}
                      />
                    </div>
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
            {formData?.settings?.download_attachment_from_url ||
            download_attachment_from_url ? (
              <FormField
                control={form.control}
                name="settings.trusted_domains"
                render={({ field }) => (
                  <FormItem>
                    <FormControl>
                      <div className="mt-[11px]">
                        <ArrayInputV2
                          label={
                            <>
                              <FormLabel>
                                Trusted Domains
                                {field?.value?.length ? (
                                  <span>({field.value.length})</span>
                                ) : null}
                              </FormLabel>
                            </>
                          }
                          placeholder="Add Domain"
                          value={field.value}
                          onChange={field.onChange}
                        />
                      </div>
                    </FormControl>
                    <FormMessage />
                  </FormItem>
                )}
              />
            ) : null}
          </div>

          <FormField
            control={form.control}
            name="settings.supported_document_types"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Supported document types</FormLabel>
                <FormControl>
                  <div>
                    <MultiSelectWithSearch
                      bindLabel="label"
                      bindValue="value"
                      placeholder="Supported document types"
                      options={SUPPORTED_DOCUMENT_LIST}
                      value={field.value}
                      onChange={field.onChange}
                      onBlur={field.onBlur}
                      noLimit={true}
                    />
                  </div>
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
          <FormField
            control={form.control}
            name="settings.subject"
            render={({ field }) => (
              <FormItem className="pt-[6px]">
                <FormControl>
                  <div>
                    <ArrayInputV2
                      label={
                        <FormLabel>
                          Subjects
                          {field?.value?.length ? (
                            <span>({field.value.length})</span>
                          ) : null}
                        </FormLabel>
                      }
                      placeholder="Add Subject"
                      value={field.value}
                      onChange={field.onChange}
                    />
                  </div>
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
          <FormField
            control={form.control}
            name="settings.ignore_document_types"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Ignore Document Types</FormLabel>
                <FormControl>
                  <div>
                    <MultiSelectWithSearch
                      bindLabel="label"
                      bindValue="value"
                      placeholder="Ignore Document Types"
                      options={[
                        ...SUPPORTED_DOCUMENT_LIST,
                        ...[
                          { label: ".msg", value: ".msg" },
                          { label: ".eml", value: ".eml" },
                        ],
                      ]}
                      value={field.value}
                      onChange={field.onChange}
                      onBlur={field.onBlur}
                      noLimit={true}
                    />
                  </div>
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
          <div>
            {ignore_document_types?.length &&
            ignore_document_types?.length !== 0 ? (
              <FormField
                control={form.control}
                name="settings.read_body_content_for_ignored_attachments"
                render={({ field }) => (
                  <FormItem>
                    <FormLabel>
                      Read body content for ignored attachments
                    </FormLabel>
                    <FormControl>
                      <div>
                        <Switch
                          className="mt-[5px]"
                          checked={field.value}
                          onCheckedChange={field.onChange}
                        />
                      </div>
                    </FormControl>
                    <FormMessage />
                  </FormItem>
                )}
              />
            ) : null}
          </div>
          <FormField
            control={form.control}
            name="settings.sender_emails"
            render={({ field }) => (
              <FormItem>
                <FormControl>
                  <div>
                    <ArrayInputV2
                      label={
                        <>
                          <FormLabel>
                            Allowed Senders{" "}
                            {field?.value?.length ? (
                              <span>({field.value.length})</span>
                            ) : null}
                          </FormLabel>
                        </>
                      }
                      placeholder="Add Sender emails"
                      value={field.value}
                      onChange={field.onChange}
                      validation="email"
                      message="Invalid email address"
                      separator="space"
                    />
                  </div>
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
          <div className="col-span-2">
            <FormField
              control={form.control}
              name="settings.sender_email_settings"
              render={({ field }) => (
                <FormItem>
                  <FormControl>
                    <div>
                      <SenderEmailSettings
                        setIsDisable={setIsDisable}
                        label={
                          <>
                            <FormLabel className="text-md font-semibold  w-full  inline-block  ">
                              Sender email settings
                            </FormLabel>
                          </>
                        }
                        placeholder="Supported document types"
                        value={field.value}
                        onChange={field.onChange}
                      />
                    </div>
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
          </div>
        </div>
        <hr className="mt-5" />
        <DialogFooter className="p-6 flex !justify-start">
          <Button
            type="button"
            className="w-[120px]"
            disabled={form.formState.isSubmitting || isDisable}
            onClick={() => {
              // e.preventDefault(); // stop immediate submit
              setTimeout(() => {
                form.handleSubmit(onSubmit)();
                // form.handleSubmit(onSubmit)(e); // call after 1s
              }, 100);
            }}
          >
            {form.formState.isSubmitting ? (
              <IconRender
                name="LoaderCircle"
                className="w-5 animate-spin text-white zoom-in-150"
              />
            ) : (
              "Save"
            )}
          </Button>
          <Button
            type="button"
            onClick={() => onOpenChange(false)}
            variant={"outline"}
            className="w-[120px]"
          >
            Close
          </Button>
        </DialogFooter>
      </form>
    </Form>
  );
};
